<template>
  <b-nav-item-dropdown
    class="dropdown-notification"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="count.count_unread_notifications"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <feather-icon class="mr-50" icon="BellIcon" size="22" />
        <h4 class="notification-title mb-0 mr-auto">Notifications</h4>
        <b-badge
          pill
          variant="light-primary"
          v-if="count.count_unread_notifications"
        >
          {{ count.count_unread_notifications }} New
        </b-badge>
      </div>
    </li>
    <!-- <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
      v-if="loading"
    > -->
    <div v-if="loading">
      <b-skeleton v-for="i in 2" :key="i" height="50px" class="my-1" />
    </div>

    <!-- </vue-perfect-scrollbar> -->
    <!-- Notifications -->
    <!-- <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
      ref="scroll"
      @ps-scroll-y="onScroll"
      v-else-if="notifications.length"
    > -->
    <div style="height: 100vh">
      <b-link
        v-for="(notification, index) in notifications"
        :key="index"
        class="bg-dark"
      >
        <b-media
          :class="[
            notification.read_at ? ' ' : '',
            'align-items-center p-1   ',
          ]"
        >
          <template #aside>
            <b-avatar
              size="32"
              :variant="notificationObject(notification).iconColor"
              rounded
            >
              <feather-icon :icon="notificationObject(notification).icon" />
            </b-avatar>
          </template>
          <div>
            <p
              class="media-heading mb-0 d-flex align-items-center justify-content-between"
            >
              <span class="font-weight-normal"
                >{{ notificationObject(notification).title }}
              </span>
              <small class="font-weight-bolder">{{
                notificationObject(notification).created_at
              }}</small>
            </p>
            <small class="notification-text">{{
              notification && notification.data && notification.data.message
                ? notification.data.message
                : ""
            }}</small>
          </div>
          <div
            class="d-flex align-items-center justify-content-end"
            v-if="!notification.read_at"
          >
            <b-button
              variant="primary"
              size="sm"
              @click="read(notification.id)"
            >
              read
            </b-button>
          </div>
        </b-media>
      </b-link>
    </div>

    <!-- </vue-perfect-scrollbar> -->

    <!-- <li class="dropdown-menu-footer">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
        >Read all notifications</b-button
      >
    </li> -->
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
  BSkeleton,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
    BSkeleton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      notifications: [],
      loading: false,
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
      count: {},
      interval: "",
    };
  },
  methods: {
    onScroll(e) {
      if (
        this.$refs.scroll.$el.scrollHeight -
          this.$refs.scroll.$el.lastElementChild.scrollHeight ==
          this.$refs.scroll.$el.scrollTop &&
        this.pagination.total_pages > this.pagination.current_page
      ) {
        this.getNotifications(this.pagination.current_page + 1);
      }
    },
    notificationObject(notification) {
      return notification.data.type === "CHARGE"
        ? {
            title: "Charge",
            icon: "ArrowDownCircleIcon",
            iconColor: "success",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "WITHDRAW"
        ? {
            title: "Widthraw",
            icon: "ArrowUpCircleIcon",
            iconColor: "danger",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "BUY_PLAN"
        ? {
            title: "Buy plan",
            icon: "FlagIcon",
            iconColor: "info",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "COMPETITION_START_PARTNER" ||
          notification.data.type === "COMPETITION_START_PARTICIPANT"
        ? {
            title: "Competition start",
            icon: "CheckIcon",
            iconColor: "warning",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "COMPETITION_END_PARTNER" ||
          notification.data.type === "COMPETITION_END_PARTICIPANT"
        ? {
            title: "Competition end",
            icon: "XIcon",
            iconColor: "danger",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "WELCOME_COMPETITION"
        ? {
            title: "Welcome",
            icon: "CoffeeIcon",
            iconColor: "info",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "COMPLETE_COMEPTITION"
        ? {
            title: "Complete competition",
            icon: "AwardIcon",
            iconColor: "success",
            created_at: this.toLocal(notification.created_at),
          }
        : notification.data.type === "COMEPTITION_BUY"
        ? {
            title: "Competition buy",
            icon: "CheckIcon",
            iconColor: "success",
            created_at: this.toLocal(notification.created_at),
          }
        : { icon: "", iconColor: "" };
    },
    async getNotifications(page) {
      try {
        const params = {
          per_page: 8,
          page: page || 1,
        };
        const { data } = await this.$http.get("/panel/notifications", {
          params,
        });
        if (page) {
          this.notifications.push(...data.data);
        } else {
          this.notifications = data.data;
        }
        this.pagination = data.meta.pagination;
      } catch (error) {}
    },
    async getCount() {
      try {
        const { data } = await this.$http.get("/panel/notifications/count");
        this.count = data;
      } catch (error) {}
    },
    async read(id) {
      this.loading = true;
      try {
        const { data } = await this.$http.post(
          `/panel/notifications/${id}?_method=patch`
        );
        this.notifications = [];
        await this.getNotifications();
        await this.getCount();
      } catch (error) {}
      this.loading = false;
    },
  },
  async created() {
    this.loading = true;
    await this.getNotifications();
    await this.getCount();
    this.loading = false;
    this.interval = setInterval(() => {
      this.getNotifications();
      this.getCount();
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style></style>
